import $ from 'jquery';
import { setCookie } from '../../core/Utils';

var selectors = {
  countBadge: '.js-header__wishlist-articles-count'
};

var cssClasses = {
  hidden: 'is-hidden'
};

var $cartCountBadge;
var currentTimestamp = 0;

export function init() {
  $cartCountBadge = $(selectors.countBadge);
  $.subscribe('update.wishlist:counter', updateCounter);
}

export function destroy() {
  $.unsubscribe('.wishlist:counter');
}

function updateCounter(event, data) {
  if (!isLatest(data.changed)) {
    return;
  }

  // update timestamp
  currentTimestamp = data.changed;

  // set cookie
  setCookie('wishlistItemsCount', data.wishlistItemsCount);

  // update counter
  $cartCountBadge.text(data.wishlistItemsCount);

  if (data.wishlistItemsCount === 0) {
    toggleBadge(true);
  } else {
    toggleBadge(false);
  }
}

function toggleBadge(bool) {
  $cartCountBadge.toggleClass(cssClasses.hidden, bool);
}

function isLatest(newTimestamp) {
  return currentTimestamp < newTimestamp;
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/layout/header/wishlist.js
 **/